import { Divider, Stack } from "@mui/material";
import PackageCardInfoSection from "./oldPackageCardInfoSection";
import { PackageItemLineType } from "./oldPackageItemLine";
import PackageItemLines from "./oldPackageItemLines";

type PackageCardContentProps = {
  packageName: string;
  packagePrice: number;
  description: string;
  packageItems: PackageItemLineType[];
  isFocused: boolean;
  isMobile: boolean;
};

export default function PackageCardContent({
  packageName,
  packagePrice,
  description,
  packageItems,
  isFocused,
  isMobile,
}: PackageCardContentProps) {
  return (
    <Stack>
      <PackageCardInfoSection
        title={packageName}
        unitPrice={packagePrice}
        description={description}
        isFocused={isFocused}
        isMobile={isMobile}
      />

      <Divider sx={{ my: 1 }} />

      <PackageItemLines
        items={packageItems}
        isFocused={isFocused}
        isMobile={isMobile}
      />
    </Stack>
  );
}
